import { Routes, Route } from "react-router-dom";

import { VenueLineLink, VenueWebPass } from "../default/pages/VenuePass";

/** SoulChat Web の場所（BAR など）を持つ作品の LIFF。LINE と Web をつなぐ 2 種類の画面だけ。 */
export default function VenueRoutes() {
  return (
    <Routes>
      <Route path="line-link" element={<VenueLineLink />} />
      <Route path=":page" element={<VenueWebPass />} />
    </Routes>
  );
}
